import { SecurityDetails } from "../../simulations/models/securityDetails";
import { Geography } from "../models/geography";
import { Sector } from "../models/sector";
import { CModelRepo } from "../cmodel.repo";

class CreateSecurityDialogController implements angular.IOnInit {
  public security: SecurityDetails;
  public geographies: Geography[];
  public sectors: Sector[];
  public fixedIncomeTypes: any;
  public assetClass: any;
  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];

  public isSaving = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private cModelRepo: CModelRepo,
    private notifyjs: any
  ) {}

  $onInit(): void {
    this.security = <SecurityDetails>{
      assetClass: {
        name: this.assetClass,
      },
    };
  }

  saveSecurity() {
    this.isSaving = true;
    this.cModelRepo
      .saveSecurity(this.security)
      .then((savedSecurity) => this.$mdDialog.hide(savedSecurity))
      .catch((err) => this.notifyjs(err.data, "warning"))
      .finally(() => (this.isSaving = false));
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

export const createSecurityDialog: angular.IComponentOptions = {
  template: require("./createSecurity.dialog.html"),
  controller: CreateSecurityDialogController,
  bindings: {
    geographies: "<",
    sectors: "<",
    assetClass: "<",
    fixedIncomeTypes: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.securitymanagement/createSecurity.dialog.ts